"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containerPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const sizes = ['1', '2', '3', '4'];
const displayValues = ['none', 'initial'];
const alignValues = ['left', 'center', 'right'];
const containerPropDefs = {
    asChild: index_js_1.asChildProp,
    size: {
        type: 'enum',
        className: 'rt-r-size',
        values: sizes,
        default: '4',
        responsive: true,
    },
    display: {
        type: 'enum',
        className: 'rt-r-display',
        values: displayValues,
        parseValue: parseDisplayValue,
        default: undefined,
        responsive: true,
    },
    align: {
        type: 'enum',
        className: 'rt-r-ai',
        values: alignValues,
        parseValue: parseAlignValue,
        default: undefined,
        responsive: true,
    },
};
exports.containerPropDefs = containerPropDefs;
function parseDisplayValue(value) {
    return value === 'initial' ? 'flex' : value;
}
function parseAlignValue(value) {
    return value === 'left' ? 'start' : value === 'right' ? 'end' : value;
}
//# sourceMappingURL=container.props.js.map